// Lead detail (build item 11): buyer identity, quick-stage chips, items &
// prices, notes and the What-Happened-So-Far timeline. hideShellChrome per
// the design's isDetail branch (see lib/router/static-data.ts) — this screen
// renders its own back/Edit bar in `LeadDetailView`, full-bleed.
import { createFileRoute } from '@tanstack/react-router';

import { LeadDetailView } from '@/components/lead-detail/lead-detail-view';

export const Route = createFileRoute('/_app/leads/$leadId/')({
  staticData: { hideShellChrome: true },
  component: LeadDetailRoute
});

function LeadDetailRoute() {
  const { leadId } = Route.useParams();
  return <LeadDetailView leadId={leadId} />;
}
